import { render, staticRenderFns } from "./PredefinedView.vue?vue&type=template&id=1627b93d&"
import script from "./PredefinedView.vue?vue&type=script&lang=js&"
export * from "./PredefinedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports